<template>
  <v-content>
    <v-toolbar app color="primary">
      <v-spacer class="hidden-sm-and-up" />
      <v-toolbar-title>
        <img
          src="@/assets/back-office/logo.png"
          alt="weserve"
          width="200px"
          style="padding-top: 10px"
        />
      </v-toolbar-title>
      <v-spacer />

      <div class="text-xs-center" v-if="isAuth">
        <v-menu v-model="menu" offset-y>
          <v-btn slot="activator" color="#333" dark icon>
            <v-icon>person</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon medium>person</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ role }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ user_name }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-btn flat block @click="$store.dispatch('logout')" v-if="isAuth"
            >Log out</v-btn
          >
        </v-menu>
      </div>
    </v-toolbar>
    <v-layout align-center justify-center row fill-height>
      <v-flex xs12 sm6>
        <Login />
      </v-flex>
      <v-footer app class="pa-3">
        <div>WESERVE BACKOFFICE v{{ pjson.version || "" }}</div>
        <v-spacer></v-spacer>
        <div>&copy; 2019 Powered by WESERVE</div>
      </v-footer>
    </v-layout>
  </v-content>
</template>

<script>
import pjson from "./../../package.json";
import Login from "@/pages/back-office/Login/index.vue";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      pjson,
      menu: "",
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapState({
      role: (state) => state.role,
      authInfo: (state) => state.authInfo,
      user_name: (state) => state.user_name,
    }),
    ...mapGetters({
      isAuth: "isAuth",
    }),
  },
};
</script>

<style scoped>
</style>